import { styled } from '@mui/material/styles';
import { getThemeSpacingCssPx } from 'components/ui/utilities/theme';

// justifyContent: 'flex-end' is deliberately NOT set here: browsers don't reliably report
// scrollWidth for a flex-end-justified row's leading-edge overflow, which broke overflow
// detection. Trailing-alignment instead comes from SecondaryNavigationScrollableActionsGroup's
// marginLeft: 'auto', which only pushes content right when there's room to do so — when content
// overflows, auto margins resolve to 0 and it overflows normally (the well-supported direction).
export const SecondaryNavigationScrollableActions = styled('div')({
  alignItems: 'center',
  display: 'flex',
  flex: '1 1 auto',
  minWidth: 0,
  overflowX: 'auto',
  overscrollBehaviorX: 'contain',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

export const SecondaryNavigationScrollableActionsGroup = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: getThemeSpacingCssPx(theme, 's'),
  marginLeft: 'auto',
}));
